import { Change, EntityType } from '@texas/api/endpoints/trackerApi';
import {
  UnifiedHistoryEvents,
  unifiedHistoryKeys,
} from '@texas/api/historyTypes';
import {
  ensureEnumKey,
  ensureEnumNumber,
} from '@texas/utils/helpers/enumHelpers';
import { TFunction } from 'i18next';

export function entityTypeFriendlyName(t: TFunction, type: EntityType) {
  switch (ensureEnumNumber(EntityType, type)) {
    case EntityType.Sample:
      return t('sample.samples');
    case EntityType.ProductApproval: {
      return t('productApproval.productApproval');
    }
    case EntityType.CompositionGroup: {
      return t('general.version');
    }
    case EntityType.Variant: {
      return t('variant.variant');
    }
    case EntityType.Article: {
      return t('article.article');
    }
    case EntityType.Concept: {
      return t('general.concept');
    }
    case EntityType.Customer: {
      return t('general.brand');
    }
    case EntityType.Supplier: {
      return t('suppliers.supplier');
    }
    case EntityType.Inquiry: {
      return t('inquiry.inquiry');
    }
    case EntityType.Offer: {
      return t('offer.offer');
    }
  }
}

export function getTrackedChangeFriendlyName(change: Change, t: TFunction) {
  const type = ensureEnumKey(
    unifiedHistoryKeys,
    change.eventType,
  ) as unknown as keyof UnifiedHistoryEvents;

  return t(`history.types.${type}`);
}
